import { html } from "htm/preact";
import { hydrate } from "preact";
import MuxPauseButton from "../components/MuxPauseButton.js";
const el = document.getElementById("mux-pause-button-island");
if (el) {
  hydrate(html`<${MuxPauseButton} />`, el);
}